const FONT_NAME_MADEFOR = 'Madefor';
export const isMadeForLoaded = () => {
    let result = false;
    try {
        document.fonts.forEach(font => {
            if (font.family === FONT_NAME_MADEFOR) {
                result = true;
            }
        });
    }
    catch (e) {
        console.error(e);
    }
    return result;
};
export const loadMadeFor = async () => {
    try {
        if (!isMadeForLoaded()) {
            const fontFaces = isVariableFontsSupported() ? getVariableFontFaces() : getLegacyFontFaces();
            for (const fontFace of fontFaces) {
                await fontFace.load();
                document.fonts.add(fontFace);
            }
        }
    }
    catch (e) {
        console.error(e);
    }
};
export const isVariableFontsSupported = () => {
    if ('CSS' in window === false || 'supports' in CSS === false) {
        return false;
    }
    return CSS.supports('(font-variation-settings: normal)');
};
const getVariableFontFaces = () => {
    return [
        new FontFace(FONT_NAME_MADEFOR, 'url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforTextVF_W_Wght.8022447a.woff2) format("woff2-variations")', {
            display: 'swap',
            weight: '400 800',
            style: 'normal',
        }),
        new FontFace(FONT_NAME_MADEFOR, 'url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforTextVF_W_Wght.8022447a.woff2) format("woff2-variations")', {
            display: 'swap',
            weight: '400 800',
            style: 'italic',
        }),
    ];
};
const getLegacyFontFaces = () => {
    return [
        new FontFace(FONT_NAME_MADEFOR, 'url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforText_W_Rg.5a5798be.woff2) format("woff2"), url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforText_W_Rg.1a0ca11a.woff) format("woff")', {
            display: 'swap',
            weight: '400',
            style: 'normal',
        }),
        new FontFace(FONT_NAME_MADEFOR, 'url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforText_W_Rg_It.12f3cd9d.woff2) format("woff2"), url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforText_W_Rg_It.8e17780b.woff) format("woff")', {
            display: 'swap',
            weight: '400',
            style: 'italic',
        }),
        new FontFace(FONT_NAME_MADEFOR, 'url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforText_W_Bd.9d07f9d7.woff2) format("woff2"), url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforText_W_Bd.1b77caba.woff) format("woff")', {
            display: 'swap',
            weight: '700',
            style: 'normal',
        }),
        new FontFace(FONT_NAME_MADEFOR, 'url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforText_W_Bd_It.31766fc9.woff2) format("woff2"), url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforText_W_Bd_It.95574030.woff) format("woff")', {
            display: 'swap',
            weight: '700',
            style: 'italic',
        }),
        new FontFace(FONT_NAME_MADEFOR, 'url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforText_W_XBd.bcb42c9a.woff2) format("woff2"), url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforText_W_XBd.068dbf77.woff) format("woff")', {
            display: 'swap',
            weight: '800',
            style: 'normal',
        }),
        new FontFace(FONT_NAME_MADEFOR, 'url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforText_W_XBd_It.9d580e0e.woff2) format("woff2"), url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforText_W_XBd_It.631cda9a.woff) format("woff")', {
            display: 'swap',
            weight: '800',
            style: 'italic',
        }),
    ];
};
